import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../../Config';
import { customStyles } from '../../../../../HelperFunctions';
import Select from "react-select";

const AddSubGroupType = ({
  show,
  handleClose,
  onSuccess,
  parentData,
  loadingParent,
  groupTypeData,
  loadingGroupType,
  refresh,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [parentOptions, setParentOptions] = useState([]);
  const [parentId, setParentId] = useState();
  //   const [groupTypeOptions, setGroupTypeOptions] = useState([]);

  useEffect(() => {
    if (parentData) {
      let arr = [];
      parentData.map((val) => {
        arr.push({ value: val.id, label: val.name });
      });
      setParentOptions(arr);
    }
  }, [parentData]);

  const closeButtonRef = useRef(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("GroupType is required."),
  });

  const groupTypeOptions = useMemo(() => {
    if (!parentId || !groupTypeData) return [];

    return groupTypeData
      .filter((item) => item.parent_group_id == parentId) // FIXED KEY
      .map((item) => ({
        value: item.id,
        label: item.name,
      }));
  }, [parentId, groupTypeData]);

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "", // Initial value for the RequiredService type
      parent_id: "",
      group_id: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const response = await fetch(
          `${adminMainUrl}/api/account/sub-group-type`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
              user_id: Cookies.get("flexichain_user_id"),
            },
            body: JSON.stringify(values),
          }
        );

        const data = await response.json();

        if (response.ok) {
          // closeButtonRef.current.click();
          refresh();
          if (onSuccess) onSuccess();
          toast.success(data?.msg);
          handleClose();
          formik.resetForm();
        } else {
          toast.error(data?.msg);
          // Handle errors from the server
          console.error("Error creating RequiredService Type:", data.message);
        }
      } catch (error) {
        console.error("Network error:", error);
      } finally {
        setIsSubmitting(false); // Stop the spinner
      }
    },
  });
  return (
    <Offcanvas
      className="custom-offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Add GroupType</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-12 mt-2">
              <label htmlFor="name" className="form-label">
                Sub Group Type <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="error">{formik.errors.name}</div>
              ) : null}
            </div>

            <div className={`col-12 mt-2`}>
              <div className="">
                <label htmlFor="" className="form-label  mb-0">
                  Parent
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <Select
                    className="custom-selector"
                    options={parentOptions}
                    styles={customStyles}
                    name="parent_id"
                    onChange={(option) => {
                      formik.setFieldValue("parent_id", option.value);
                      setParentId(option.value);
                    }}
                    value={
                      parentOptions?.find(
                        (option) => option.value == formik.values.parent_id
                      ) || null
                    }
                    isLoading={loadingParent}
                  />
                </div>
              </div>
            </div>

            <div className={`col-12 mt-2`}>
              <div className="">
                <label htmlFor="" className="form-label  mb-0">
                  Group Type
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <Select
                    className="custom-selector"
                    options={groupTypeOptions}
                    styles={customStyles}
                    name="group_id"
                    onChange={(option) => {
                      formik.setFieldValue("group_id", option.value);
                    }}
                    value={
                      groupTypeOptions?.find(
                        (option) => option.value == formik.values.group_id
                      ) || null
                    }
                    isLoading={loadingGroupType}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary text-xs"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <i className="fa fa-spinner fa-spin" />
              ) : (
                "Submit"
              )}
            </button>
          </div> */}

          <div className="row d-flex justify-content-end mt-4">
            <div className="col-md-6 d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-sm btn-danger"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Saving...
                  </>
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddSubGroupType